var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3932_3056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3513 3.97366C12.6597 3.66533 12.833 3.2471 12.8331 2.811C12.8331 2.37489 12.6599 1.95662 12.3516 1.64821C12.0433 1.33979 11.625 1.1665 11.1889 1.16644C10.7528 1.16639 10.3345 1.33958 10.0261 1.64792L2.24097 9.43483C2.10553 9.56987 2.00537 9.73614 1.9493 9.919L1.17872 12.4577C1.16364 12.5081 1.1625 12.5617 1.17542 12.6127C1.18834 12.6638 1.21484 12.7104 1.2521 12.7476C1.28936 12.7848 1.33599 12.8112 1.38706 12.824C1.43812 12.8369 1.49171 12.8357 1.54213 12.8205L4.08138 12.0505C4.26406 11.9949 4.43032 11.8954 4.56555 11.7606L12.3513 3.97366Z",
    stroke: "#6B7280",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3932_3056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.e0419764d78d34e39ecfdde95a7ecec2.svg";
export { ForwardRef as ReactComponent };